import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';
import { BreadcrumbsItem } from 'core/components';

import PageHvnTransitGatewayAttachmentsConfigurationInstructions from 'hcp/components/page/hvn-transit-gateway-attachments/configuration-instructions';

<template>
  {{pageTitle (t "page-title.hvn-transit-gateway-attachments.detail")}}

  <BreadcrumbsItem
    @route="cloud.orgs.detail.projects.detail.hvns.detail.transit-gateway-attachments.detail"
    @text={{@controller.model.tgwAttachment.id}}
  />

  <BreadcrumbsItem
    @route="cloud.orgs.detail.projects.detail.hvns.detail.transit-gateway-attachments.detail.configuration-instructions"
    @text={{t
      "components.page.hvn-transit-gateway-attachments.detail.configuration-instructions.title"
    }}
  />

  <PageHvnTransitGatewayAttachmentsConfigurationInstructions
    @model={{@controller.model}}
    @tab={{@controller.model.tab}}
    @product={{@controller.model.product}}
  />
</template>
